import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import jwt from 'jsonwebtoken'; // const cfc = (s = '') => `${s.slice(0, 1).toUpperCase()}${s.slice(1)}`;
// const extS = (ex) => (s) => `${ex}${cfc(s)}`;
// const cnv = (ext, obj) =>
//    ((e) => Object.keys(obj).reduce((r, key) => ({ ...r, [e(key)]: obj[key] }), {}))(extS(ext));

/**
 * Vygeneruje lazy inicializator statu AuhtProvider-u.
 *
 * @param {() => string} getAccessToken
 * @param {(accessToken: string) => void} setAccessToken
 * @param {() => void} authCallBack
 * @param {Object} param3
 * @param {atring} [param3.accessToken]
 * @param {boolean} [param3.isAuthenticated]
 * @param {Object} [param3.meta]
 * @param {Array<string>} [param3.scope]
 * @param {string} param3.storeKey
 * @param {Object} [param3.user]
 */

export default function createAuthContextInitializator(getStoredAuthData, setStoredAuthData, authCallBack, _ref) {
  var initialIsAuthenticated = _ref.isAuthenticated,
      initialData = _objectWithoutProperties(_ref, ["isAuthenticated"]);

  return function () {
    var _ref2 = function () {
      var sdx = getStoredAuthData();

      if (!sdx && (initialData.accessToken || initialData.scope)) {
        setStoredAuthData(initialData);
      }

      var sd = sdx || initialData;
      var act = sd.accessToken;
      var now = Date.now().valueOf() / 1000;

      var _ref4 = jwt.decode(act) || {
        exp: now - 1
      },
          exp = _ref4.exp,
          nbf = _ref4.nbf;

      if (typeof exp !== 'undefined' && exp > now) {
        return [true, act, sd];
      }

      if (typeof nbf !== 'undefined' && nbf < now) {
        return [true, act, sd];
      }

      setStoredAuthData(undefined);
      return [false, undefined, {}];
    }(),
        _ref3 = _slicedToArray(_ref2, 3),
        validToken = _ref3[0],
        accessToken = _ref3[1],
        storedData = _ref3[2];

    var isAuthenticated = !!initialIsAuthenticated || validToken;

    if (isAuthenticated) {
      authCallBack();
    }

    return _extends({}, isAuthenticated ? storedData : {}, {
      accessToken: accessToken,
      scope: (isAuthenticated ? storedData.scope : undefined) || [''],
      isAuthenticated: isAuthenticated
    });
  };
}